import _ from 'lodash';

export const MINIMUM_TIME_PICKER_VALUE = 0;
export const MAXIMUM_TIME_PICKER_VALUE = 1440;
export const TIME_PICKER_PERIOD = 30;
export const TIME_PICKER_VALUES = (() =>
  _.range(MINIMUM_TIME_PICKER_VALUE, MAXIMUM_TIME_PICKER_VALUE + 30, TIME_PICKER_PERIOD))();
export const DEFAULT_TIME_PICKER_VALUE = 540 as const;
export const DEFAULT_SET_AVAILABILITY_INTERVAL = { start: DEFAULT_TIME_PICKER_VALUE, end: 600 } as const;
